import React, { useContext, useEffect, useState, useRef } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { Badge, Card, Col, Modal, Row, Table, Button } from "react-bootstrap";
import { Footer } from "../../Footer";
import { ChartAdd2 } from "../Outer/ChartAdd2";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  AuctionAll,
  AuctionCount,
  BidAll,
  BidWinnerList,
  GetBidAmountReport,
  GetBidCountDetail,
  GetReportData,
  GetSubScription,
} from "../../redux/auth-reducer/auth-service";
import { ImageUrl } from "../../utils/config/config";
import dayjs from "dayjs";
import { Context } from "../../redux/Context";
import introJs from 'intro.js';
import 'intro.js/introjs.css';
import { useSelector } from "react-redux";

export const Player_dashboard = () => {
  const [data, setData] = useState(false);
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [itemListRecent, setItemListRecent] = useState([]);
  const [itemDataBidWin, setItemDataBidWin] = useState([]);
  const [dataBidWindLn, setDataBidWindLn] = useState();
  const [itemCountData, setItemCountData] = useState();
  const [activeTab, setActiveTab] = useState("BidAlll");
  const [bidWonAmount, setBidWonAmount] = useState("");
  const { hubConnection } = useContext(Context);
  const [investedBiddingAmount, setInvestedBiddingAmount] = useState("");
  const [dataSubscription, setDataSubscription] = useState();
  const [show, setShow] = useState(false);
  const [messageSubscribe, setMessageSubscribe] = useState()
  const loginInstructionStatus = useSelector(state => state?.instruction?.status);

  const [countvalue, setCountValue] = useState({
    bidcount: "",
    auctioncount: "",
  });
  let instructionStatus = localStorage.getItem("instruction");
  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const loginInstruction =  isUser?.isUserInstruction;

  function sidebarfun() {
    setData(!data);
  }
  useEffect(() => {
    const isAuth = localStorage.getItem("role");
    if (isAuth == "Player") {
    } else {
      navigate("/Login");
    }
  }, []);

  useEffect(() => {
    const AuctionAllFn = async () => {
      await AuctionAll().then((response) => {
        setItemList(response?.data?.data?.dataList);
      });
    };
    AuctionAllFn();
  }, []);

  useEffect(() => {
    const AuctionAllFn = async () => {
      await BidAll().then((response) => {
        const firstThreeObjects = response?.data?.data?.dataList.slice(0, 5);
        setItemListRecent(firstThreeObjects);
      });
    };
    AuctionAllFn();
  }, []);

  useEffect(() => {
    const BidWinFn = async () => {
      await BidWinnerList().then((response) => {
        setDataBidWindLn(response?.data?.length);
        setItemDataBidWin(response?.data?.data?.dataList);
      });
    };
    BidWinFn();
  }, []);

  useEffect(() => {
    const BidCountFn = async () => {
      await GetBidCountDetail().then((response) => {
        setItemCountData(response?.data);
      });
    };
    BidCountFn();
  }, []);

  useEffect(() => {
    async function apiCalling() {
      let res = await GetBidCountDetail();
      let response = await AuctionCount();
      setCountValue({
        bidcount: res?.data?.totalBidCount,
        auctioncount: response?.activeCount,
      });
    }
    apiCalling();
  }, []);

  useEffect(() => {
    const ReportDataFn = async () => {
      await GetBidAmountReport().then((res) => {
        setBidWonAmount(res?.data?.bidWonAmount);
        setInvestedBiddingAmount(res?.data?.investedBiddingAmount);
      });
    };
    ReportDataFn();
  }, []);

  const placeBtn = (e) => {
    const buttonValue = e.target.value;

    // navigate(`/Player/PlaceBid?auctionId`, { state: detailsToSend });
  };

  const handleButtonClick = () => {
    if (activeTab !== "Winner") {
      setActiveTab("Winner");
    }
    navigate("/Player/Bid", { state: activeTab });
  };

  useEffect(() => {
    if (hubConnection) {
      // Listen for messages from the SignalR hub
      hubConnection.on("ReceiveBidStatus", (data) => {
        // Update itemList based on the received data
        setItemList((prevItemList) => {
          return prevItemList.map((item) => {
            // Find the updated item based on auctionId and teamId
            const updatedItem = data.find(
              (d) => d.auctionId === item.auctionId && d.teamId === item.teamId
            ); // Assuming teamId is part of the data

            if (updatedItem) {
              return { ...item, status: updatedItem.status }; // Update the status if found
            }
            return item; // Return the original item if no update is found
          });
        });
      });

      return () => {
        hubConnection.off("ReceiveBidStatus");
      };
    }
  }, [hubConnection]);

  useEffect(() => {
    const GetBySubscriptionFn = async () => {
      try {
        const response = await GetSubScription();
        const data = response?.data?.data;
        setMessageSubscribe(response?.data?.message)
        setShow(true);
        // Check if data exists and has entries
        if (data && data.length > 0) {
          // Get the last entry
          const lastEntry = data[data.length - 1];
          setDataSubscription(lastEntry);
        }
      } catch (error) {
        console.error("Error fetching subscription data:", error);
      }
    };

    GetBySubscriptionFn();
  }, []);
  const handleClose = () => setShow(false);

  const isRole = localStorage.getItem("role");

  // Determine subscription status
  const isSubscriptionActive = () => {
    if (isRole !== "Player") {
      return true; // Bypass subscription check for non-Player roles
    }

    if (!dataSubscription || !dataSubscription.subscriptionEndDate) {
      return false; // No subscription or no end date for Player
    }

    const currentDateTime = dayjs();
    const subscriptionEndDate = dayjs(
      dataSubscription.subscriptionEndDate + "Z"
    );
    return subscriptionEndDate.isAfter(currentDateTime); // Active if end date is in the future
  };

  
  const hasTourStarted = useRef(false);
  const steps = [
                  {
                    element: '#Auction',
                    // intro: 'Click on Auction tab and redirect the Action page.',
                    intro: 'Click the Next button to proceed to the Auction page, where you can browse and participate in ongoing and upcoming player auctions.',
                    position: 'right'
                  },
                ];


                  const startTour = () => {
                    introJs().setOptions({
                      steps: steps,
                      showBullets: false,
                      nextLabel: 'Next',
                      prevLabel: 'Previous',
                      doneLabel: 'Next',
                      exitOnOverlayClick: false,
                      skipLabel: '',
                    }).oncomplete(() => {
                        navigate("/player/AuctionPlayer");
                    }).start();
                  };
                  
                  // const startTour = () => {
                  //   introJs().setOptions({
                  //     steps: steps,
                  //     showBullets: false,
                  //     nextLabel: 'Next',
                  //     prevLabel: 'Previous',
                  //     doneLabel: 'Finish',
                  //     exitOnOverlayClick: false,
                  //      skipLabel: '', 
                  //   }).start();
                  // };
                  useEffect(() => {
                    if ((!hasTourStarted.current && loginInstruction === true && loginInstructionStatus === loginInstruction) || instructionStatus === 'true') {
                      startTour();
                      hasTourStarted.current = true;
                    }
                  }, [instructionStatus]);
                  

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Dashboard</h1>
          {!isSubscriptionActive() ? (
            <Modal centered show={show} id='subscribe_modal'>
              <Modal.Header
                className="promo-code-header className promo-close"
                closeButton
              >
                <Modal.Title>
                  <b>Subscription Notification</b>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h6>
                  You are not subscribed or subscription expired. Please
                  subscribe to participate in auctions.
                </h6>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  href="/Player/Account_settings"
                  className="subscribe-link"
                  variant="primary"
                >
                  Subscribe Now
                </Button>
              </Modal.Footer>
            </Modal>
          ) : null}
          <Row>
            <Col>
              <Link
                // to="/Player/Bid" className="Link-to-page"
                to="/Player/Bid" // Just the path string
                state={{         // Pass the state using the 'state' prop
                  targetTab: "BidAlll",
                }} 
                className="Link-to-page"
              >
                <div className="item-list" id="bidNumber">
                  <div className="group-list1">
                    <div className="image-icon2">
                      <img src="../image/Bids.png" alt="user"></img>
                    </div>
                    <div className="content">
                      <h2>
                        {itemCountData?.totalCount == null
                          ? "0"
                          : itemCountData?.totalCount}
                      </h2>
                      <p>Total number of bids </p>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>

            <Col>
              <Link to="/Player/AuctionPlayer" className="Link-to-page">
                <div className="item-list" id="runing">
                  <div className="group-list1">
                    <div className="image-icon1">
                      <img src="../image/oragnization.svg" alt=""></img>
                    </div>
                    <div className="content">
                      <h2>
                        {countvalue?.auctioncount == null
                          ? "0"
                          : countvalue?.auctioncount}
                      </h2>
                      <p>Total running auction</p>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
            <Col>
              <Link 
                // to="/Player/Bid"
                to="/Player/Bid" // Just the path string
                state={{         // Pass the state using the 'state' prop
                  targetTab: "Winner",
                }} 
              className="Link-to-page"
            >
                <div className="item-list" id="bidWon">
                  <div className="group-list1">
                    <div className="image-icon">
                      <img src="../image/BidWon.png" alt="user"></img>
                    </div>
                    <div className="content">
                      <h2>
                        {itemCountData?.activeCount > 0
                          ? itemCountData?.activeCount
                          : 0}
                      </h2>

                      <p>Total number of bids won</p>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
            <Col>
              <Link to="/Player/Bid" className="Link-to-page">
                <div className="item-list" id="bidLos">
                  <div className="group-list1">
                    <div className="image-icon3">
                      <img src="../image/BidLost.png" alt="user"></img>
                    </div>
                    <div className="content">
                      <h2>{itemCountData?.expiredCount}</h2>
                      <p>Total number of bids lost</p>
                    </div>
                  </div>
                </div>
              </Link>
            </Col>
          </Row>

          <Row>
            <Col sm={7}>
              <Card className="mt-4 height-sec">
                <Row>
                  <Col md="6" xs="6">
                    {" "}
                    <h2>Bid Won Listing</h2>
                  </Col>
                  <Col md="6" xs="6" className="text-right">
                    <Link to="/Player/Bid">View All</Link>
                  </Col>
                  <Col md="12 orgnization-table ">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Auction Name</th>
                          <th>Team Name</th>

                          <th>Bid Amount</th>
                          <th>Manager Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemDataBidWin?.slice(0, 4).map((item) => (
                          <tr>
                            <td>{item?.auctionName}</td>
                            <td>{item?.teamName}</td>

                            <td>{item?.bidAmount}</td>
                            <td>{item?.createdByName}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col sm={5} className="mt-4 chart">
              <Card className="Chart-sec">
                <h3>Reports</h3>

                <div className="group-sec">
                  <Row>
                    <Col md="6">
                      <div className="group-chart">
                        <ChartAdd2
                          bidWonAmount={bidWonAmount}
                          investedBiddingAmount={investedBiddingAmount}
                        />
                        {bidWonAmount && investedBiddingAmount > 0 ? (
                          <img
                            src="../image/Group-11553.png"
                            className="image-auction"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Col>

                    <Col lg="6">
                      <Row className="mt-3">
                        <div className="d-flex">
                          <div className="list-circle me-2"></div>{" "}
                          <p className="text-color-tab">
                            Bid Won Amount - {bidWonAmount}
                          </p>
                        </div>
                        <div className="d-flex ">
                          <div className="list-circle-up  me-2"></div>
                          <p className="text-color-tab">
                            {" "}
                            Invested Bidding Amount - {investedBiddingAmount}
                          </p>
                        </div>
                      </Row>
                    </Col>
                  </Row>

                  {/* <div className="total Balance">
                    Balance
                    <div className="amount-text">0</div>
                  </div> */}
                </div>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12 orgnization-table">
              <Card className="Bidder-sec-recent mt-4">
                <Row>
                  <Col md="6" xs="6">
                    <h2>Recent Bids</h2>
                  </Col>
                  <Col md="6" xs="6" className="text-right">
                    <Link to="/Player/Bid">View All</Link>
                  </Col>
                </Row>

                <Table responsive>
                  <thead>
                    <tr>
                      <th>Auction Name</th>
                      <th>Team Name</th>
                      <th>Current Bid Amount</th>
                      <th>Min Bid</th>
                      <th>Date and Time</th>

                      <th>Min Bid Increment</th>
                      <th>Manager Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemListRecent?.map((item) => {
                      return (
                        <>
                          <tr>
                            <td>{item?.auctionName}</td>
                            <td>{item?.teamName}</td>
                            <td>{item?.currentBidAmount}</td>
                            <td>{item?.startingBid}</td>
                            <td>
                              {dayjs(item?.startDate + "Z").format(
                                "MM/DD/YYYY hh:mm:ss A"
                              )}
                            </td>

                            <td>{item?.bidIncrement}</td>
                            <td>{item?.createdByName}</td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
          <Row>
            {itemList?.slice(0, 4).map((item) => {
              return (
                <>
                  <Col className="mt-3">
                    <Link to="/player/AuctionPlayer">
                      <Card className="p-2 group-image-auction">
                        {item?.status == "Live" ? (
                          <Badge bg="success" className="LiveButton">
                            {item?.status}
                          </Badge>
                        ) : item?.status == "Upcoming" ? (
                          <Badge bg="primary" className="LiveButton">
                            {item?.status}
                          </Badge>
                        ) : (
                          <Badge bg="danger" className="LiveButton">
                            {item?.status}
                          </Badge>
                        )}

                        {item?.auctionImage == null ? (
                          <img
                            src="/image/auction.png"
                            className="auctionImage"
                          />
                        ) : (
                          <img
                            src={ImageUrl + item?.auctionImage}
                            className="img-fluid auctionImage"
                          ></img>
                        )}

                        <h5 className="mt-3 auction-list-h">
                          {item?.auctionName}
                        </h5>
                        <p>
                          Start Date and Time:
                          {dayjs(item?.startDate + "Z").format(
                            "MM/DD/YYYY hh:mm:ss A"
                          )}
                        </p>
                      </Card>
                    </Link>
                  </Col>
                </>
              );
            })}
          </Row>
          <Footer className="mt-2 mb-3" />
        </div>
      </div>
    </>
  );
};
